import Box from '@mui/material/Box';
import { DoseData } from '~/state/atoms/dose/doseAtoms';
import DoseActionMenu from './dose-action-menu';
import DoseSettingsDialog from './dose-settings-dialog';
import DoseVisibilityToggle from './DoseVisibilityToggle';

export default function DoseHeader({ dose }: { dose?: DoseData }) {
    return (
        <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            width="100%"
            position="relative"
        >
            {dose && (
                <Box display="flex" alignItems="center" ml="auto" gap={0.5}>
                    <Box display="flex" alignItems="center" gap={0.5}>
                        <DoseSettingsDialog />
                        <DoseVisibilityToggle />
                    </Box>
                    <DoseActionMenu />
                </Box>
            )}
        </Box>
    );
}
